// @ts-nocheck
import { useEffect, useRef } from "react";
import { useT } from "../i18n";

// Oudere KitchenControl-modules bevatten nog vaste Nederlandse JSX-teksten.
// Deze scope vertaalt alleen interface-tekst. Door gebruikers ingevoerde data
// (taaknamen, producten, leveranciers, notities, historie) blijft ongewijzigd.
const LEGACY_EN = {
  "Home": "Home",
  "Begin": "Home",
  "Recepten": "Recipes",
  "Recept": "Recipe",
  "Ingrediënt": "Ingredient",
  "Ingrediënten": "Ingredients",
  "Zoeken op recept...": "Search recipes...",
  "Zoeken op recept…": "Search recipes…",
  "Recept toevoegen": "Add recipe",
  "+ Recept toevoegen": "+ Add recipe",
  "Extra filters": "Extra filters",
  "Alle": "All",
  "Vlees": "Meat",
  "Vis": "Fish",
  "Soepen": "Soups",
  "Sauzen": "Sauces",
  "Dessert": "Dessert",
  "Overig": "Other",

  "Medewerkers": "Staff",
  "Medewerker": "Employee",
  "Medewerker toevoegen": "Add employee",
  "+ Medewerker toevoegen": "+ Add employee",
  "Werktijden": "Working hours",
  "Week": "Week",
  "Exporteer (CSV)": "Export (CSV)",
  "Totaal": "Total",
  "TOTAAL": "TOTAL",
  "Ma": "Mon",
  "Di": "Tue",
  "Wo": "Wed",
  "Do": "Thu",
  "Vr": "Fri",
  "Za": "Sat",
  "Zo": "Sun",

  // HACCP algemeen
  "Schoonmaak": "Cleaning",
  "Temperatuur": "Temperature",
  "Ontvangst": "Receiving",
  "Terugkoelen": "Cooling down",
  "Allergenen": "Allergens",
  "Afwijkingen": "Deviations",
  "Hygiëne": "Hygiene",
  "NVWA Rapport": "NVWA report",
  "gesynchroniseerd": "synced",
  "synchroniseren…": "syncing…",
  "Vandaag": "Today",
  "Deze week": "This week",
  "Deze periode": "This period",
  "Alles geregistreerd": "All logged",
  "Afwijkingen vandaag": "Deviations today",
  "Registraties (laatste 5)": "Registrations (last 5)",
  "REGISTRATIES (LAATSTE 5)": "REGISTRATIONS (LAST 5)",
  "Geschiedenis": "History",
  "Geschiedenis (laatste 5)": "History (last 5)",
  "HISTORY (LAST 5)": "HISTORY (LAST 5)",
  "Meer tonen": "Show more",
  "Minder tonen": "Show less",
  "Geen registraties.": "No registrations.",
  "Nog geen registraties.": "No registrations yet.",

  // Beheerblokken
  "Beheren": "Manage",
  "Beheer": "Management",
  "Schoonmaaktaken beheren": "Manage cleaning tasks",
  "Taak beheren": "Manage task",
  "+ Taak beheren": "+ Manage task",
  "Leveranciers beheren": "Manage suppliers",
  "Leverancier beheren": "Manage supplier",
  "+ Leverancier beheren": "+ Manage supplier",
  "Koelunits beheren": "Manage cooling units",
  "Koelunit beheren": "Manage cooling unit",
  "+ Koelunit beheren": "+ Manage cooling unit",
  "Gerechten beheren": "Manage dishes",
  "Allergenen beheren": "Manage allergens",
  "Toevoegen, wijzigen en verwijderen vraagt de beheer-pincode.": "Adding, editing and deleting requires the management PIN.",
  "Nieuwe taak": "New task",
  "Taak": "Task",
  "Naam": "Name",
  "Frequentie": "Frequency",
  "Opslaan": "Save",
  "Annuleren": "Cancel",
  "Verwijderen": "Delete",
  "Bewerken": "Edit",
  "Toevoegen": "Add",
  "Sluiten": "Close",

  // Schoonmaak
  "Dagelijks": "Daily",
  "Wekelijks": "Weekly",
  "4-wekelijks": "Every 4 weeks",
  "Dagelijkse taken": "Daily tasks",
  "Wekelijkse taken": "Weekly tasks",
  "4-wekelijkse taken": "4-weekly tasks",
  "Geregistreerd": "Logged",
  "geregistreerd": "logged",
  "Nog niet uitgevoerd": "Not yet completed",
  "Uitgevoerd": "Completed",
  "Ongedaan maken": "Undo",
  "Afvinken": "Complete",
  "Kies medewerker": "Choose employee",
  "Bezig…": "Working…",
  "Bezig...": "Working...",
  "Termijn verstreken!": "Due date passed!",
  "Nog geen taken.": "No tasks yet.",
  "Nog geen dagelijkse taken.": "No daily tasks yet.",
  "Nog geen wekelijkse taken.": "No weekly tasks yet.",
  "Nog geen vierweekse taken. Voeg ze toe via Beheren hierboven.": "No 4-weekly tasks yet. Add them via Manage above.",
  "Nog geen vierweekse taken. Voeg ze toe via Manage hierboven.": "No 4-weekly tasks yet. Add them via Manage above.",

  // Formuliervelden algemeen
  "Datum": "Date",
  "Tijd": "Time",
  "Opmerking": "Note",
  "Notitie": "Note",
  "Optioneel...": "Optional...",
  "Optioneel…": "Optional…",
  "Geen": "None",
  "Ja": "Yes",
  "Nee": "No",
  "Ja / Nee?": "Yes / No?",
  "Akkoord": "Approved",
  "Afgekeurd": "Rejected",
  "Controle": "Check",
  "Status": "Status",

  // Temperatuur
  "Koeling": "Fridge",
  "Koelingen": "Fridges",
  "Vriezer": "Freezer",
  "Vriezers": "Freezers",
  "Koelunit": "Cooling unit",
  "Kies koelunit...": "Choose cooling unit...",
  "Kies koelunit…": "Choose cooling unit…",
  "Gerecht": "Dish",
  "Temperatuur registreren": "Log temperature",
  "Gemeten temperatuur": "Measured temperature",
  "Temperatuur °C": "Temperature °C",
  "Maatregel": "Corrective action",
  "Maatregelen": "Corrective actions",
  "Deur gecontroleerd": "Door checked",
  "Thermostaat bijgesteld": "Thermostat adjusted",
  "Producten verplaatst": "Products moved",
  "Technische dienst gebeld": "Technical service called",
  "Binnen norm": "Within limit",
  "Buiten norm": "Outside limit",
  "Norm": "Limit",

  // Ontvangst
  "Afwijking": "Deviation",
  "Afwijking registreren": "Log deviation",
  "Corrigerende maatregel": "Corrective action",
  "Ontvangst registreren": "Log delivery",
  "Goederenontvangst": "Goods receiving",
  "Leverancier": "Supplier",
  "Leveranciers": "Suppliers",
  "Kies leverancier...": "Choose supplier...",
  "Kies leverancier…": "Choose supplier…",
  "Product": "Product",
  "Producten": "Products",
  "Productnaam": "Product name",
  "Temp °C": "Temp °C",
  "THT/TGT OK": "Best-before/use-by OK",
  "Verpakking": "Packaging",
  "Verpakking OK": "Packaging OK",
  "Partij": "Batch",
  "LOG DELIVERY": "LOG DELIVERY",

  // Terugkoelen
  "Terugkoeling": "Cooling",
  "Terugkoeling starten": "Start cooling",
  "Start terugkoeling": "Start cooling",
  "START COOLING": "START COOLING",
  "Afronden": "Finish",
  "Starttemperatuur": "Start temperature",
  "Starttemperatuur °C": "Start temperature °C",
  "Begintemperatuur °C": "Start temperature °C",
  "Eindtemperatuur": "End temperature",
  "Eindtemperatuur °C": "End temperature °C",
  "Starttijd": "Start time",
  "Begintijd": "Start time",
  "Eindtijd": "End time",
  "Duur": "Duration",
  "Langste duur": "Longest duration",
  "LANGSTE DUUR": "LONGEST DURATION",
  "Lopend": "In progress",
  "Afgerond": "Completed",
  "Lopende terugkoelingen": "Active cooling processes",
  "Geen lopende terugkoelingen": "No active cooling processes",
  "Naam product": "Product name",
  "Norm: binnen 5 uur terugkoelen tot ≤7°C": "Limit: cool down to ≤7°C within 5 hours",
  "Norm: binnen 5 uur terugkoelen tot ≤7 °C": "Limit: cool down to ≤7°C within 5 hours",

  // Allergenen / afwijkingen / hygiëne
  "Allergeen": "Allergen",
  "Gerecht toevoegen": "Add dish",
  "Hygiënecontrole": "Hygiene check",
  "Hygiëne registreren": "Log hygiene check",
  "Persoonlijke hygiëne": "Personal hygiene",
  "Schoon": "Clean",
  "Niet schoon": "Not clean",
  "Open": "Open",
  "open": "open",
  "Klaar": "Done",
  "klaar": "done",

  // Instellingen
  "Instellingen": "Settings",
  "Bedrijf": "Company",
  "Bedrijfsnaam": "Company name",
  "Bedrijfsgegevens": "Company details",
  "Bedrijfsinstellingen": "Company settings",
  "Plaats": "Location",
  "Plaats voor weer": "Weather location",
  "Weerlocatie": "Weather location",
  "Logo": "Logo",
  "Logo URL": "Logo URL",
  "Logo-url": "Logo URL",
  "Opslaan instellingen": "Save settings",
  "Wijzigingen opslaan": "Save changes",
  "Account": "Account",
  "Mijn account": "My account",
  "E-mailadres": "Email address",
  "E-mail": "Email",
  "Schermnaam": "Display name",
  "Roepnaam": "Display name",
  "Rol": "Role",
  "Beheerder": "Owner",
  "Manager": "Manager",
  "Medewerker": "Employee",
  "Wachtwoord": "Password",
  "Nieuw wachtwoord": "New password",
  "Herhaal wachtwoord": "Repeat password",
  "Wachtwoord wijzigen": "Change password",
  "Gebruik minstens 8 tekens.": "Use at least 8 characters.",
  "De wachtwoorden komen niet overeen.": "The passwords do not match.",
  "Geen verbinding met de server.": "No connection to the server.",
  "Opgeslagen": "Saved",
  "Beheer-pincode": "Management PIN",
  "Pincode": "PIN",
  "Nieuwe pincode": "New PIN",
  "Herhaal pincode": "Repeat PIN",
  "Pincode opslaan": "Save PIN",
  "Pincode wijzigen": "Change PIN",
  "Pincode uitschakelen": "Disable PIN",
  "Beheer ontgrendelen": "Unlock management",
  "Beheer vergrendelen": "Lock management",
  "Beheer is ontgrendeld": "Management is unlocked",
  "Beheer is vergrendeld": "Management is locked",
  "Pincode opslaan lukte niet.": "Could not save PIN.",
  "Gebruikers": "Users",
  "Collega's": "Colleagues",
  "Collega toevoegen": "Add colleague",
  "Persoonlijk account uitnodigen": "Invite personal account",
  "Voornaam": "First name",
  "Vul een voornaam in.": "Enter a first name.",
  "Vul een e-mailadres in.": "Enter an email address.",
  "Uitnodigen": "Invite",
  "Uitnodiging": "Invitation",
  "Uitnodigingen": "Invitations",
  "Openstaande uitnodigingen": "Pending invitations",
  "Opnieuw mailen": "Resend email",
  "Intrekken": "Revoke",
  "Toegang intrekken": "Revoke access",
  "Huidige gebruikers": "Current users",
  "Leden": "Members",
  "Actief": "Active",
  "Uitgenodigd": "Invited",
  "Export & back-up": "Export & backup",
  "Export en back-up": "Export and backup",
  "Back-up": "Backup",
  "Exporteren": "Export",
  "Importeren": "Import",
  "Herstellen": "Restore",
  "Gegevens exporteren": "Export data",
  "Gegevens herstellen": "Restore data",
  "Download back-up": "Download backup",
  "Back-up herstellen": "Restore backup",
  "Selecteer onderdelen": "Select sections",
  "Alles selecteren": "Select all",
  "Mise en Place": "Mise en place",
  "Juridisch": "Legal",
  "Algemene voorwaarden": "Terms and conditions",
  "Privacyverklaring": "Privacy policy",
  "Printer": "Printer",
  "Printkastje": "Print box",
  "Printserver": "Print server",
  "Printserver URL": "Print server URL",
  "Printerinstellingen": "Printer settings",
  "Verbinding": "Connection",
  "Verbonden": "Connected",
  "Niet verbonden": "Not connected",
  "Online": "Online",
  "Offline": "Offline",
};

const MONTHS = {
  januari: "January", februari: "February", maart: "March", april: "April",
  mei: "May", juni: "June", juli: "July", augustus: "August",
  september: "September", oktober: "October", november: "November", december: "December",
};
const WEEKDAYS = {
  maandag: "Monday", dinsdag: "Tuesday", woensdag: "Wednesday", donderdag: "Thursday",
  vrijdag: "Friday", zaterdag: "Saturday", zondag: "Sunday",
};

function fallbackEnglish(text) {
  if (LEGACY_EN[text]) return LEGACY_EN[text];

  let out = text;

  // Alleen bekende interface-patronen. Geen vrije tekst vertalen, zodat
  // gebruikersdata en historische registraties onaangetast blijven.
  out = out.replace(/^(\d+) medewerkers?$/i, (_, n) => `${n} ${Number(n) === 1 ? "employee" : "staff members"}`);
  out = out.replace(/^(\d+) teamleden$/i, "$1 team members");
  out = out.replace(/^(\d+)\/(\d+) geregistreerd$/i, "$1/$2 logged");
  out = out.replace(/^WEEKLIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "WEEKLY TASKS · $1/$2 LOGGED");
  out = out.replace(/^DAGELIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "DAILY TASKS · $1/$2 LOGGED");
  out = out.replace(/^4-WEKELIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "4-WEEKLY TASKS · $1/$2 LOGGED");
  out = out.replace(/^(\d+) ontvangst$/i, (_, n) => `${n} ${Number(n) === 1 ? "delivery" : "deliveries"}`);
  out = out.replace(/^(\d+) ontvangsten$/i, "$1 deliveries");
  out = out.replace(/^(\d+) terugkoeling$/i, (_, n) => `${n} ${Number(n) === 1 ? "cooling process" : "cooling processes"}`);
  out = out.replace(/^(\d+) terugkoelingen$/i, "$1 cooling processes");
  out = out.replace(/^LOPENDE TERUGKOELINGEN \((\d+)\)$/i, "ACTIVE COOLING PROCESSES ($1)");
  out = out.replace(/^Registraties \(laatste (\d+)\)$/i, "Registrations (last $1)");
  out = out.replace(/^REGISTRATIES \(LAATSTE (\d+)\)$/i, "REGISTRATIONS (LAST $1)");
  out = out.replace(/^Week (\d+) · /i, "Week $1 · ");

  for (const [nl, en] of Object.entries(WEEKDAYS)) out = out.replace(new RegExp(`\\b${nl}\\b`, "gi"), en);
  for (const [nl, en] of Object.entries(MONTHS)) out = out.replace(new RegExp(`\\b${nl}\\b`, "gi"), en);
  return out;
}

// Alleen vaste interfacepatronen; vrije recept- en taakteksten worden niet vertaald.
function fallbackPolish(text) {
  return text
    .replace(/^(\d+) medewerkers?$/i, "Pracownicy: $1")
    .replace(/^(\d+) teamleden$/i, "Członkowie zespołu: $1")
    .replace(/^(\d+)\/(\d+) geregistreerd$/i, "$1/$2 zapisano")
    .replace(/^WEEKLIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "ZADANIA TYGODNIOWE · $1/$2 ZAPISANO")
    .replace(/^DAGELIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "ZADANIA CODZIENNE · $1/$2 ZAPISANO")
    .replace(/^4-WEKELIJKSE TAKEN · (\d+)\/(\d+) GEREGISTREER$/i, "ZADANIA CO 4 TYGODNIE · $1/$2 ZAPISANO")
    .replace(/^(\d+) ontvangst(?:en)?$/i, "Dostawy: $1")
    .replace(/^(\d+) terugkoeling(?:en)?$/i, "Schładzanie: $1")
    .replace(/^LOPENDE TERUGKOELINGEN \((\d+)\)$/i, "SCHŁADZANIE W TOKU ($1)")
    .replace(/^Registraties \(laatste (\d+)\)$/i, "Wpisy (ostatnie $1)")
    .replace(/^Week (\d+) · /i, "Tydzień $1 · ");
}

export default function AutoTranslateScope({ children }) {
  const rootRef = useRef(null);
  const originalsRef = useRef(new WeakMap());
  const { t, lang } = useT();

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const originals = originalsRef.current;

    const translate = (raw) => {
      if (!["en", "pl"].includes(lang) || typeof raw !== "string") return raw;
      const m = raw.match(/^(\s*)(.*?)(\s*)$/s);
      const lead = m?.[1] || "";
      const core = m?.[2] || "";
      const tail = m?.[3] || "";
      if (!core.trim()) return raw;
      const viaCentral = t(core);
      const translated = viaCentral !== core ? viaCentral : (lang === "pl" ? fallbackPolish(core) : fallbackEnglish(core));
      return lead + translated + tail;
    };

    // React kan dezelfde tekstnode hergebruiken voor nieuwe gegevens. Alleen
    // onze eigen laatste vertaling terugvertalen; nooit een oude waarde herstellen.
    const reconcile = (record, current) => {
      const original = record && current === record.last ? record.original : current;
      return { original, last: translate(original) };
    };
    const excluded = (el) => el?.closest?.('[translate="no"], [data-no-translate], [contenteditable="true"], script, style, textarea');

    const processText = (node) => {
      if (excluded(node.parentElement)) return;
      const current = node.nodeValue || "";
      const record = reconcile(originals.get(node), current);
      originals.set(node, record);
      if (current !== record.last) node.nodeValue = record.last;
    };

    const processElement = (el) => {
      if (!(el instanceof Element) || excluded(el)) return;
      let records = originals.get(el);
      if (!records) { records = {}; originals.set(el, records); }
      for (const attr of ["placeholder", "title", "aria-label"]) {
        if (!el.hasAttribute(attr)) { delete records[attr]; continue; }
        const current = el.getAttribute(attr) || "";
        records[attr] = reconcile(records[attr], current);
        if (current !== records[attr].last) el.setAttribute(attr, records[attr].last);
      }
    };

    const walk = (start) => {
      if (start.nodeType === Node.TEXT_NODE) return processText(start);
      if (!(start instanceof Element)) return;
      processElement(start);
      const walker = document.createTreeWalker(start, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeType === Node.TEXT_NODE) processText(node);
        else processElement(node);
      }
    };

    walk(root);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "characterData") processText(mutation.target);
        else if (mutation.type === "attributes") processElement(mutation.target);
        else for (const node of mutation.addedNodes) walk(node);
      }
    });
    observer.observe(root, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ["placeholder", "title", "aria-label"],
    });
    return () => observer.disconnect();
  }, [lang, t]);

  return <div ref={rootRef} style={{ display: "contents" }}>{children}</div>;
}

